import Cookies from 'js-cookie';

const siteNotices = document.querySelectorAll('.alert');

function handleSiteNoticeClose(event) {
  // Find the alert element that contains the data-id
  const alertElement = event.target.closest('.alert');
  const siteNoticeId = alertElement?.getAttribute('data-id');
  
  if (!siteNoticeId) {
    console.warn('Site notice ID not found');
    return;
  }
  
  if(Cookies.get('siteNotices')) {
    const siteNotices = JSON.parse(Cookies.get('siteNotices'));
    siteNotices.ids.push(siteNoticeId);
    Cookies.set('siteNotices', JSON.stringify(siteNotices));
  } else {
    const siteNotices = {
      ids: [siteNoticeId],
    };
    Cookies.set('siteNotices', JSON.stringify(siteNotices));
  }
}

siteNotices.forEach(siteNotice => {
  siteNotice.addEventListener('closed.bs.alert', handleSiteNoticeClose);
});